import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse, Pagination } from 'interfaces/api.interfaces'
import {
  ProjectHierarchiesResponse,
  Template,
  TemplateDataServer,
  TemplateDestroyPreview,
  UpdateTemplateFields,
} from 'interfaces/api/templates.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

import { businessTypesApi as businessTypes } from './businessTypes'
import { fieldsApi as fields } from './fields'

const getAll = async (params?: Partial<Pagination>): GetAllResponse<Template> => {
  const { data: response } = await axios.request<GetAllData<Template>>({
    method: 'GET',
    url: endpoints.templates.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
    },
  })
  return response
}

const getSingle = async (id: number): GetOneResponse<Template> => {
  const { data: response } = await axios.request<Template>({
    method: 'GET',
    url: endpoints.templates.getSingle(id),
  })
  return response
}

const create = async (data: TemplateDataServer): GetOneResponse<Template> => {
  const { data: response } = await axios.request<Template>({
    method: 'POST',
    url: endpoints.templates.create(),
    data,
  })
  return response
}

const update = async (id: number, data: TemplateDataServer): GetOneResponse<Template> => {
  const { data: response } = await axios.request<Template>({
    method: 'PATCH',
    url: endpoints.templates.update(id),
    data,
  })
  return response
}

const remove = async (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.templates.remove(id),
  })

const getDestroyPreview = async (id: number): GetOneResponse<TemplateDestroyPreview> => {
  const { data: response } = await axios.request<TemplateDestroyPreview>({
    method: 'GET',
    url: endpoints.templates.destroyPreview(id),
  })
  return response
}

const getProjectHierarchies = async (projectId: number): GetOneResponse<ProjectHierarchiesResponse> => {
  const { data: response } = await axios.request<ProjectHierarchiesResponse>({
    method: 'GET',
    url: endpoints.templates.projectHierarchies(projectId),
  })
  return response
}

const updateTemplateFields = async (templateId: number, data: UpdateTemplateFields): Promise<void> => {
  await axios.request({
    method: 'POST',
    url: endpoints.templates.updateTemplateFields(templateId),
    data,
  })
}

export const templatesApi = {
  getAll,
  getSingle,
  create,
  update,
  remove,
  updateTemplateFields,
  getDestroyPreview,
  getProjectHierarchies,
  businessTypes,
  fields,
}
